"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withContext = exports.createContext = void 0;
const json_1 = require("@stoplight/json");
function createContext(document, resolveRef, generateId) {
    let context = 'service';
    return {
        document,
        get context() {
            return context;
        },
        set context(value) {
            context = value;
            if (value !== 'operation') {
                this.parentId = this.ids[value];
            }
        },
        maybeResolveLocalRef(target) {
            if ((0, json_1.hasRef)(target) && (0, json_1.isLocalRef)(target.$ref)) {
                try {
                    return resolveRef.call(this, target);
                }
                catch {
                    return target;
                }
            }
            return target;
        },
        generateId(value) {
            this.parentId = generateId(value);
            return this.parentId;
        },
        ids: {
            service: '',
            path: '',
            operation: '',
        },
        parentId: '',
    };
}
exports.createContext = createContext;
function withContext(fn) {
    return function (...args) {
        const { context, parentId } = this;
        const result = fn.apply(this, args);
        this.context = context;
        this.parentId = parentId;
        return result;
    };
}
exports.withContext = withContext;
//# sourceMappingURL=context.js.map